import { PaymentRowKindEnum, TPaymentRowKind } from '../types/ManagePayments';
import { TPaymentActionStrategy } from '../types/PaymentKindStrategy';
import {
  batchActionStrategy,
  scheduledPaymentActionStrategy,
  scheduledTransferActionStrategy
} from './paymentActionStrategyExtensions';

/**
 * The single source of truth for "how do you delete/retry a row of this kind" - consumed by
 * useScheduledPaymentAction's confirmDelete/retry, which no longer need their own
 * `payment.kind === ...` branches at all. This file is just the registry/lookup ("process") - the
 * actual per-kind implementations live in paymentActionStrategyExtensions.ts, so adding a new
 * kind's behaviour means adding a new export there and one line here, never editing this lookup
 * logic itself. See the README's "Extending: Adding a New Row Kind" section.
 */
export const PAYMENT_ACTION_STRATEGIES: Record<TPaymentRowKind, TPaymentActionStrategy> = {
  [PaymentRowKindEnum.BATCH]: batchActionStrategy,
  [PaymentRowKindEnum.SCHEDULED_PAYMENT]: scheduledPaymentActionStrategy,
  [PaymentRowKindEnum.PENDING_SCHEDULED_PAYMENT]: scheduledPaymentActionStrategy,
  [PaymentRowKindEnum.SCHEDULED_TRANSFER]: scheduledTransferActionStrategy
};

export const getPaymentActionStrategy = (kind: TPaymentRowKind): TPaymentActionStrategy =>
  PAYMENT_ACTION_STRATEGIES[kind];
